var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStreak(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 3.99999C16.8889 7.55555 18.6667 10.4444 21.3333 12.6667C24 14.8889 25.3333 17.3333 25.3333 20C25.3333 22.4753 24.35 24.8493 22.5997 26.5997C20.8493 28.35 18.4754 29.3333 16 29.3333C13.5246 29.3333 11.1507 28.35 9.40034 26.5997C7.65 24.8493 6.66667 22.4753 6.66667 20C6.66667 18.5575 7.13452 17.154 8 16C8 16.884 8.35119 17.7319 8.97631 18.357C9.60143 18.9821 10.4493 19.3333 11.3333 19.3333C12.2174 19.3333 13.0652 18.9821 13.6904 18.357C14.3155 17.7319 14.6667 16.884 14.6667 16C14.6667 13.3333 12.6667 12 12.6667 9.33332C12.6667 7.55555 13.7778 5.77777 16 3.99999Z",
    stroke: "var(--stroke-0, #FFB86A)",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStreak);
export default __webpack_public_path__ + "static/media/icon-streak.a9880b0a2df6278f7400abd58befbd0f.svg";
export { ForwardRef as ReactComponent };